"use client";
import { Get, Patch } from "@/axios/AxiosFunctions";
import PostCompareCard from "@/components/Core/PostCompareCard";
import SideBarSkeleton from "@/components/Core/SideBarSkeleton";
import Skeleton from "@/components/Skeleton";
import { BaseURL, imageUrl } from "@/config/apiUrl";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import classes from "./SingleRequestDetail.module.css";
import { apiHeader, RenderToast } from "@/helper/HelperFunction";
import { Button } from "@/components/Core/Button";
import { REQUEST_EDIT_STATUS } from "@/constant/constants";

const LOADING_STATES = {
  GET_REQUEST_EDIT_DETAILS: "get_request_edit_details",
  ACCEPT: REQUEST_EDIT_STATUS.ACCEPT,
  REJECT: REQUEST_EDIT_STATUS.REJECT,
};

export default function SingleRequestDetail() {
  const { access_token } = useSelector((state) => state?.authReducer);
  const { postId, requestEditId } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(null);

  // fetch request edit details
  const fetchRequestEditDetails = async () => {
    const url = BaseURL(`admin/posts/find-edit/${requestEditId}`);
    setLoading(LOADING_STATES.GET_REQUEST_EDIT_DETAILS);
    const response = await Get(url, access_token);
    if (response) {
      setData(response?.data);
    }
    setLoading(null);
  };
  // handle approve reject
  const handleApproveReject = async (status) => {
    const url = BaseURL(`admin/posts/${status}-edit/${requestEditId}`);
    setLoading(status);
    const response = await Patch(url, {}, apiHeader(access_token));
    if (response) {
      RenderToast({
        type: "success",
        message: `Edit ${status} successfully`,
      });
      setData(response?.data?.edit);
    }
    setLoading(null);
  };

  useEffect(() => {
    fetchRequestEditDetails();
  }, []);

  return (
    <SideBarSkeleton>
      <div className={classes.mainWrapper}>
        {loading == LOADING_STATES.GET_REQUEST_EDIT_DETAILS ? (
          <Skeleton width="100%" height="600px" />
        ) : (
          <>
            <div className={classes.headerContainer}>
              <div className={classes.userDetails}>
                <div className={classes.userRequestFollowWrapper}>
                  <img src={imageUrl(data?.user?.image)} alt="user" />
                </div>
                <div className={classes.detailsWrapper}>
                  <div className={classes.nameDesignation}>
                    <h3 className={classes.nameDesignationHeaderTitle}>
                      {data?.user?.fullName}
                    </h3>
                    <p className={classes.emailText}>{data?.user?.email}</p>
                  </div>
                </div>
              </div>
              {data?.status == REQUEST_EDIT_STATUS.PENDING && (
                <div className={classes.buttonWrapper}>
                  <Button
                    label={
                      loading == LOADING_STATES.ACCEPT
                        ? "Accepting..."
                        : "Accept"
                    }
                    onClick={() =>
                      handleApproveReject(REQUEST_EDIT_STATUS.ACCEPT)
                    }
                    disabled={loading}
                  />
                  <Button
                    label={
                      LOADING_STATES.REJECT == loading
                        ? "Rejecting..."
                        : "Reject"
                    }
                    onClick={() =>
                      handleApproveReject(REQUEST_EDIT_STATUS.REJECT)
                    }
                    disabled={loading}
                  />
                </div>
              )}
            </div>
            <PostCompareCard data={data} />
          </>
        )}
      </div>
    </SideBarSkeleton>
  );
}
